module.exports = __webpack_public_path__ + "img/Xgrow-12-en.356e7b18.png";